<template>
    <div>
        <div 
            class="d-flex justify-content-center align-items-center height-498 background-image text-white font-glacial-bold font-120" 
            :style="`background-image: url(/wp-content/themes/rhiza/src/assets/overlay.jpg);`"
        >
            <h1 class="text-upper-case text-white font-glacial-bold font-120">
                Pesquisa
            </h1>
        </div>

        <div class="container">
            <div v-if="hasSearch">
                <gcse:searchresults-only v-pre></gcse:searchresults-only>
            </div>
            <div class="no-records" v-else>
                <h2 class="text-center">Não tem nada para ser pesquisado</h2>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            hasSearch: false
        }
    },

    created() {
        var cx = '017721937541247304537:mqdncugjike';
        var gcse = document.createElement('script'); 
        gcse.type = 'text/javascript'; 
        gcse.async = true;
        gcse.src = 'https://cse.google.com/cse.js?cx=' + cx;
        gcse.setAttribute('id', 'box-gcse')
        var s = document.getElementsByTagName('script')[0]; 
        s.parentNode.insertBefore(gcse, s);

        if (this.$route.query.q) {
            this.hasSearch = true
        }
    },
}
</script>
<style scoped>
.no-records {
    margin: 150px 0 300px;
}

@media screen and (max-width: 768px) {
    .background-image {
        margin-top: 100px;
    }

    .no-records {
        margin: 150px 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/search.vue